import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gauge, Fuel, Settings2, User, Calendar } from "lucide-react";
import { imageUrl, formatPrice, formatKms } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const CarCard = ({ car, index = 0 }) => {
  const cover = car.images?.[0];
  const { t } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 3) * 0.08 }}
    >
      <Link
        to={`/car/${car.id}`}
        className="group block bg-[#141414] border border-white/10 rounded-lg overflow-hidden hover:-translate-y-1 hover:border-[#FF3B30]/40 hover:shadow-[0_8px_30px_rgba(255,59,48,0.15)] transition-[transform,border-color,box-shadow] duration-300"
        data-testid={`car-card-${car.id}`}
      >
        <div className="aspect-video overflow-hidden bg-black relative">
          {cover ? (
            <img src={imageUrl(cover)} alt={`${car.brand} ${car.model}`} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${car.is_sold ? "opacity-50" : ""}`} />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-600 text-sm">{t("car.noImage")}</div>
          )}
          <span className="absolute top-3 left-3 bg-black/70 backdrop-blur text-white text-xs font-bold px-3 py-1 rounded-full border border-white/10 flex items-center gap-1">
            <Calendar size={12} /> {car.year}
          </span>
          {car.is_sold && (
            <span className="absolute top-3 right-3 bg-[#FF3B30] text-white text-xs font-black px-3 py-1 rounded-full shadow-lg tracking-wider" data-testid={`sold-badge-${car.id}`}>
              {t("car.sold")}
            </span>
          )}
        </div>
        <div className="p-5">
          <h3 className="font-display font-bold text-lg text-white truncate">{car.brand} {car.model}</h3>
          <p className="text-[#FF3B30] font-display font-black text-2xl mt-1">{formatPrice(car.price)}</p>

          <div className="grid grid-cols-2 gap-y-2 gap-x-3 mt-4 text-xs text-gray-400">
            <span className="flex items-center gap-1.5"><Gauge size={14} className="text-gray-500" /> {formatKms(car.kilometers)}</span>
            <span className="flex items-center gap-1.5"><Settings2 size={14} className="text-gray-500" /> {car.transmission}</span>
            <span className="flex items-center gap-1.5"><Fuel size={14} className="text-gray-500" /> {car.fuel_type}</span>
            <span className="flex items-center gap-1.5"><User size={14} className="text-gray-500" /> {car.ownership}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
